export const BUTTON_COLOR: any = {
  white: 'btn-secondary-white',
  black: 'btn-secondary-black',
  yellow: 'btn-secondary-yellow',
};
